import { apiGet, apiPut } from '@jumbo/utils/ApiHelper';
import config from 'config';

const loadApiUrl = config.loadApiUrl;
const carrierApiUrl = config.carrierApiUrl;

export function getLoadsInterestsCarrierRepsListApi() { // may be replace with new api so please ignore duplicate api
  return apiGet(loadApiUrl, 'dispatches/carrier-reps/list');
}

export function getLoadsInterestsStatesListApi() {
  return apiGet(loadApiUrl, 'admin/loads/interests/states/list');
}

export function getLoadInterestsCountApi() {
  return apiGet(loadApiUrl, `admin/loads/interests/count`);
}

export function getLoadsInterestsApi(data) {
  return apiGet(loadApiUrl, `admin/loads/interests`, data);
}

export function getLoadsInterestDetailsApi(id) {
  return apiGet(loadApiUrl, `admin/loads/interests/users/${id}`);
}

export function updateUserInterestDetailsApi(id, data) {
  return apiPut(loadApiUrl, `admin/loads/interests/${id}`, data);
}

export function getUserInterestBidsApi(id) {
  return apiGet(loadApiUrl, `admin/interests/${id}`);
}

export function getOwnerOperatorCarrierInfoApi(user_id) {
  return apiGet(carrierApiUrl, `admin/users/${user_id}/carriers`);
}